import React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExpandMore = styled(
  React.forwardRef((props, ref) => {
    const { expand, ...other } = props;
    return <IconButton {...other} ref={ref} />;
  }),
  { shouldForwardProp: (prop) => prop !== "bgcolor" }
)(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const ExpandButton = React.forwardRef(function ExpandButton(props, ref) {
  const { fontSize, ...other } = props;
  //  Spread the props to the underlying DOM element.
  return (
    <ExpandMore {...other} ref={ref}>
      <ExpandMoreIcon fontSize={fontSize} />
    </ExpandMore>
  );
});
